import { JsonObject } from 'json2typescript';
import { PortfolioInterface } from '../interfaces/portfolio.interface';

@JsonObject('Portfolio')
export class Portfolio implements PortfolioInterface {
  Agent?: Agent;
  Alias?: string;
  AllowOperations?: AllowOperations;
  AnalysisDate?: string;
  AppropriatenessClientCode?: string;
  AppropriatenessClientCodeView?: string;
  AssetClassDistribution?: any[];
  AssetTypeDistribution?: any[];
  BankCode?: string;
  BenchmarkId?: number;
  BenchmarkName?: any;
  CancelDate?: string;
  ChangingModelPortfolio?: boolean;
  ContractRelation?: string;
  CostValue?: number;
  Currency?: string;
  CurrencyDistribution?: any[];
  GlobalCurrency?: string;
  IBAN?: any;
  InitialDate?: string;
  InOutflows?: number;
  InvestmentProfileData?: InvestmentProfileData;
  InvestmentType?: string;
  IsBlocked?: boolean;
  IsOpenPortfolio?: boolean;
  LVD?: string;
  ModelPortfolioCode?: any;
  ModelPortfolioCodeView?: any;
  ModelPortfolioExternalCode?: any;
  ModelPortfolioName?: any;
  Name?: string;
  Nature?: string;
  OnboardingStatus?: string;
  OnboardingStep?: string;
  OnProductionDate?: string;
  Outlier?: boolean;
  OutProfile?: boolean;
  Performance1M?: number;
  Performance1W?: number;
  Performance1Y?: number;
  Performance1YOpen?: number;
  Performance3M?: number;
  Performance3Y?: any;
  Performance5Y?: any;
  PerformanceStartDate?: number;
  PerformanceStartDateAnualized?: number;
  PerformanceYTD?: number;
  PortfolioCode?: string;
  PortfolioCodeView?: string;
  PortfolioHaveComponents?: boolean;
  ProfitLoss?: number;
  ProfitLossGlobalCurrency?: number;
  ProfitLossPercent?: number;
  RatioSharpe?: any;
  ServiceModelBehavior?: string;
  ServiceModelCode?: string;
  ServiceModelName?: string;
  TotalProfitLossBeetweenDatesPercent?: number;
  TrendStrength?: number;
  Type?: string;
  UnrealizedProfitLoss?: number;
  UnrealizedProfitLossPercent?: number;
  Valuation?: number;
  ValuationDate?: string;
  ValuationGlobalCurrency?: number;
  Var1Y95?: number;
  Volatility?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('Agent')
export class Agent {
  Code?: string;
  Email?: string;
  FullName?: string;
  Phone?: string;
  UserCode?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('AllowOperations')
export class AllowOperations {
  AllowBuy?: boolean;
  AllowChangeModelPortfolio?: boolean;
  AllowContribution?: boolean;
  AllowProposals?: boolean;
  AllowSell?: boolean;
  AllowWithdrawal?: boolean;

  ActivityId?: number;
  AllowCancelContribution: boolean;
  AllowOperatePortfolio: boolean;
  AllowPortfolioProfile: boolean;
  MessageBuy?: string;
  MessageCancelContribution?: string;
  MessageCancelWithdrawal?: string;
  MessageChangeModelPortfolio?: string;
  MessageContribution?: string;
  MessageOperatePortfolio?: string;
  MessagePortfolioProfile?: string;
  MessageProposals?: string;
  MessageSell?: string;
  MessageWithdrawal?: string;
  VisibleBuy?: boolean;
  VisibleCancelContribution?: boolean;
  VisibleCancelWithdrawal?: boolean;
  VisibleChangeModelPortfolio?: boolean;
  VisibleContribution?: boolean;
  VisibleOperatePortfolio?: boolean;
  VisiblePortfolioProfile?: boolean;
  VisibleProposals?: boolean;
  VisibleSell?: boolean;
  VisibleWithdrawal?: boolean;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('InvestmentProfileData')
export class InvestmentProfileData {
  ProfileId?: string;
  ProfileName?: string;
  ProfileScore?: number;
  ProfileTestId?: string;
  ProfileTestSignatureStatus?: any;
  ProfileTestSignatureType?: any;
  TestDate?: any;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
